import { render, staticRenderFns } from "./amountContentItem.vue?vue&type=template&id=1c43364d&scoped=true&"
import script from "./amountContentItem.vue?vue&type=script&lang=js&"
export * from "./amountContentItem.vue?vue&type=script&lang=js&"
import style0 from "./amountContentItem.vue?vue&type=style&index=0&id=1c43364d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c43364d",
  null
  
)

export default component.exports